module.exports = __webpack_public_path__ + "img/more.f5c825a9.png";